// packages/main/app/web/components-v2/UnifiedImageDialog/AIEditTab.tsx
import * as Api from '@ViewModels';
import * as React from 'react';
import { useBrandingSettingsQuery } from '../../../queries';
import { hasBrandingSettings } from '../../../utils/hasBrandingSettings';
import { AIImageChat } from './AIImageChat';
import { useAddAIImageToLibrary } from './useAddAIImageToLibrary';

interface AIEditTabProps {
	initialImage: Api.IFileAttachment;
	existingConversationId?: string;
	onImageSelected: (image: Api.IFileAttachment) => void;
	onConversationCreated?: (conversationId: string) => void;
	impersonationContext?: Api.IImpersonationContext;
	addToLibrary?: boolean;
}

export function AIEditTab({
	initialImage,
	existingConversationId,
	onImageSelected,
	onConversationCreated,
	impersonationContext,
	addToLibrary,
}: AIEditTabProps) {
	const selectImage = useAddAIImageToLibrary({ addToLibrary, impersonationContext, onImageSelected });

	// Adapt AIImageChat's array callback to AIEditTab's single image callback
	const handleImageSelected = React.useCallback(
		(fileAttachments: Api.IFileAttachment[]) => {
			if (fileAttachments.length > 0) {
				selectImage(fileAttachments[0]);
			}
		},
		[selectImage]
	);

	const { data: brandingSettings } = useBrandingSettingsQuery({
		enabled: true,
		impersonationContext,
	});

	return (
		<AIImageChat
			initialImages={[initialImage]}
			existingConversationId={existingConversationId}
			onImageSelected={handleImageSelected}
			onConversationCreated={onConversationCreated}
			impersonationContext={impersonationContext}
			showApplyBrandingButton={hasBrandingSettings(brandingSettings)}
		/>
	);
}
